<template>
    <component
            :is="getComponent"
            :item="getObject"
            :field="field"
            :show-label="showLabel"
    >
    </component>
</template>

<script>

  import TextColumn from '@/components/tablefields/Text'
  import DateColumn from '@/components/tablefields/Date'
  import Relations from '@/components/tablefields/Relations'
  import Matrix from '@/components/tablefields/Matrix'
  import LightSwitch from '@/components/tablefields/LightSwitch'
  import MissingComponent from '@/components/tablefields/MissingComponent'

  export default {
    name: 'DynamicRow',
    props: {
      field: {
        required: true,
        type: Object
      },
      item: {
        default: null,
        type: Object
      },
      showLabel: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      getComponent () {
        switch (this.field.type) {
          case 'craft\\fields\\Date':
            return DateColumn
          case 'craft\\fields\\Lightswitch':
            return LightSwitch
          case 'craft\\fields\\Matrix':
            return Matrix
          case 'modules\\raumkarte\\fields\\Categories':
          case 'craft\\fields\\Dropdown':
            return Relations
          case 'craft\\fields\\PlainText':
          case 'craft\\fields\\Number':
            return TextColumn
          default:
            return MissingComponent
        }
      },
      getObject () {
        let object = null

        if (this.item.layer === this.field.layerId) {
          object = this.item
        } else if (Array.isArray(this.item.objects)) {
          // search for objects
          object = this.item.objects.find((el) => el.layer === this.field.layerId)
        }

        return object || null
      }
    }
  }
</script>

<style scoped>

</style>